import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconToolsMaxAngleSizeS from './IconToolsMaxAngle_size_s';

const props: CreateIconArguments = {
  l: IconToolsMaxAngleSizeS,
  m: IconToolsMaxAngleSizeS,
  s: IconToolsMaxAngleSizeS,
  xs: IconToolsMaxAngleSizeS,
  name: 'IconToolsMaxAngle',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
